<script>
	import Router from "svelte-spa-router";
	import Inicio from "./paginas/inicio.svelte";
	import Carga from "./paginas/carga.svelte";
	import Lista from "./paginas/lista.svelte";
	import Calendario from "./componentes/calendario.svelte";
	let routes = {
		"/":Carga,
		"/home":Inicio,
		"/lista/:id":Calendario
	}
</script>

<Router {routes} />

<style>
	:global(body){
		background: lightgray;
	}
</style>
